import { useState } from "react";
import Drawer from 'react-modern-drawer';

export default function CustomFilter(param: any) {

  let [isOpen, setIsOpen] = useState(param.CustomFilterOpen);

  
  let [filterSelection, SetFilterSelection] = useState<any>([]);

  const onCloseDrawer = () => {
    param.onChange();
    isOpen = false;
    setIsOpen(isOpen)
  }

  const resetFilter = () => {
  }

  const searchFilter = () => {
  }

  return (<>
    <Drawer open={isOpen}
      onClose={() => setIsOpen(false)}
      direction='right'
      className='react-drawer allowHscroll allowVscroll'
      size={800}>
      <div className="box noBorderRadius noBorder ws-6 pull-right">


        <div className="box-header noBorderRadius bg-blue pLarge">Filter </div>

        {
          (() => {
            if (param.type == "CueListing") {

              return (
                <div className="ws-12 ">
                  <div className="ws-6 pm">
                    <label className="ws-12 text-bold">Master Cue</label>
                    <input type="text" id="masterCue" name="masterCue" className="ws-10" placeholder="Master Cue" value={filterSelection.masterCue} onChange={(e) => SetFilterSelection({ ...filterSelection, masterCue: e.target.value, })}/>
                  </div>

                  <div className="ws-6 pm">
                    <label className="ws-12 text-bold">Cue Theme</label>
                    <input type="text" id="cueTheme" name="cueTheme" className="ws-10" placeholder="Cue Theme" value={filterSelection.cueTheme} onChange={(e) => SetFilterSelection({ ...filterSelection, cueTheme: e.target.value, })}/>
                  </div>

                  <div className="ws-6 pm">
                    <label className="ws-12 text-bold">Cue Sheet Type</label>
                    <select id="cueSheetType" name="cueSheetType" className="ws-10" value={filterSelection.cueSheetType} onChange={(e) => SetFilterSelection({ ...filterSelection, cueSheetType: e.target.value, })}>
                      <option value="">Choose cue sheet type</option>
                      {global?.cueSheetType?.map((values: any) => {
                        return (<option className="width200">{values?.cueSheetTypeDesc}</option>)
                      })}
                    </select>
                  </div>

                  <div className="ws-6 pm">
                    <label className="ws-12 text-bold">Cue Status</label>
                    <select id="cueStatus" name="cueStatus" className="ws-10" value={filterSelection.cueStatus} onChange={(e) => SetFilterSelection({ ...filterSelection, cueStatus: e.target.value, })}>
                      <option value="">Choose Status</option>
                      <option value="in-setup">In Set-up</option>
                      <option value="approved">APPROVED</option>
                    </select>
                  </div>

                  <div className="ws-6 pm">
                    <label className="ws-12 text-bold">Program Number</label>
                    <input type="text" id="programNumber" name="programNumber" className="ws-10" placeholder="Program Number" value={filterSelection.programNumber} onChange={(e) => SetFilterSelection({ ...filterSelection, programNumber: e.target.value, })}/>
                  </div>

                  <div className="ws-6 pm">
                    <label className="ws-12 text-bold">Extended Status</label>
                    <select id="extendedStatus" name="extendedStatus" className="ws-10" value={filterSelection.extendedStatus} onChange={(e) => SetFilterSelection({ ...filterSelection, extendedStatus: e.target.value, })}>
                      <option value="">Choose Status</option>
                      <option value="all">ALL</option>
                      <option value="usd">USD</option>
                    </select>
                  </div>

                  <div className="ws-6 pm">
                    <label className="ws-12 text-bold">Production Id</label>
                    <input type="text" id="productionId" name="productionId" className="ws-10" placeholder="Production Id" value={filterSelection.productionId} onChange={(e) => SetFilterSelection({ ...filterSelection, productionId: e.target.value, })}/>
                  </div>

                  <div className="ws-6" aria-hidden="true"></div>
                </div>
              )
            }

            if (param.type == "CueProductListing") {
              <div className="ws-12">
                <div className="ws-4 pm">
                  <label className="ws-4 text-bold">Master Cue</label>
                  <input type="text" id="masterCue" name="masterCue" className="ws-8" placeholder="Master Cue" value={filterSelection.masterCue} onChange={(e) => SetFilterSelection({ ...filterSelection, masterCue: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-4 text-bold">Cue Theme</label>
                  <input type="text" id="cueTheme" name="cueTheme" className="ws-8" placeholder="Cue Theme" value={filterSelection.cueTheme} onChange={(e) => SetFilterSelection({ ...filterSelection, cueTheme: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-4 text-bold">Cue Sheet Type</label>
                  <select id="cueSheetType" name="cueSheetType" className="ws-8">
                    <option value="">Choose cue sheet type</option>
                    {global?.cueSheetType?.map((values: any) => {
                      return (<option className="width200">{values?.cueSheetTypeDesc}</option>)
                    })}
                  </select>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-4 text-bold">Cue Status</label>
                  <select id="cueStatus" name="cueStatus" className="ws-8" value={filterSelection.cueStatus} onChange={(e) => SetFilterSelection({ ...filterSelection, cueStatus: e.target.value, })}>
                    <option value="">Choose Status</option>
                    {global?.statusProduct?.map((values: any) => {
                      return (<option className="width200">{values.ProductStatusShortCode}</option>)
                    })}
                  </select>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-4 text-bold">Program Number</label>
                  <input type="text" id="programNumber" name="programNumber" className="ws-8" placeholder="Program Number" value={filterSelection.programNumber} onChange={(e) => SetFilterSelection({ ...filterSelection, programNumber: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-4 text-bold">Extended Status</label>
                  <select id="extendedStatus" name="extendedStatus" className="ws-8" value={filterSelection.extendedStatus} onChange={(e) => SetFilterSelection({ ...filterSelection, extendedStatus: e.target.value, })}>
                    <option value="">Choose Status</option>
                    {global?.statusProductExt?.map((values: any) => {
                      return (<option className="width200">{values.productStatusExtName}</option>)
                    })}
                  </select>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-4 text-bold">Production Id</label>
                  <input type="text" id="productionId" name="productionId" className="ws-8" placeholder="Production Id" value={filterSelection.productionId} onChange={(e) => SetFilterSelection({ ...filterSelection, productionId: e.target.value, })}/>
                </div>
              </div>
            }

            if (param.type == "CueSerieListing") {
              <div className="ws-12">

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Cue Sheet Type</label>
                  <select id="cueSheetType" name="cueSheetType" className="ws-8" value={filterSelection.cueSheetType} onChange={(e) => SetFilterSelection({ ...filterSelection, cueSheetType: e.target.value, })}>
                    <option value="">Choose cue sheet type</option>
                    {global?.cueSheetType?.map((values: any) => {
                      return (<option className="width200">{values?.cueSheetTypeDesc}</option>)
                    })}
                  </select>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Name</label>
                  <input type="text" id="seriesName" name="seriesName" className="ws-11" placeholder="Series Name" value={filterSelection.seriesName} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesName: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Production Num</label>
                  <input type="text" id="seriesProductionNum" name="seriesProductionNum" className="ws-11" placeholder="Series Production Num" value={filterSelection.seriesProductionNum} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesProductionNum: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Production ID</label>
                  <input type="text" id="productionId" name="productionId" className="ws-11" placeholder="Production ID" value={filterSelection.productionId} onChange={(e) => SetFilterSelection({ ...filterSelection, productionId: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Category</label>
                  <input type="text" id="seriesCategory" name="seriesCategory" className="ws-11" placeholder="Series Category" value={filterSelection.seriesCategory} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesCategory: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Version</label>
                  <input type="text" id="seriesVersion" name="seriesVersion" className="ws-11" placeholder="Series Version" value={filterSelection.seriesVersion} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesVersion: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Duration Minute</label>
                  <input type="number" id="seriesDurationMinute" name="seriesDurationMinute" className="ws-11" placeholder="Series Duration Minute" value={filterSelection.seriesDurationMinute} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesDurationMinute: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Duration Second</label>
                  <input type="number" id="seriesDurationSecond" name="seriesDurationSecond" className="ws-11" placeholder="Series Duration Second" value={filterSelection.seriesDurationSecond} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesDurationSecond: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Language</label>
                  <input type="text" id="seriesLanguage" name="seriesLanguage" className="ws-11" placeholder="Series Language" value={filterSelection.seriesLanguage} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesLanguage: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Comments</label>
                  <input type="text" id="seriesComments" name="seriesComments" className="ws-11" placeholder="Series Comments" value={filterSelection.seriesComments} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesComments: e.target.value, })}/>
                </div>

                <div className="ws-4 pm">
                  <label className="ws-12 text-bold">Series Instructions</label>
                  <input type="text" id="seriesInstructions" name="seriesInstructions" className="ws-11" placeholder="Series Instructions" value={filterSelection.seriesInstructions} onChange={(e) => SetFilterSelection({ ...filterSelection, seriesInstructions: e.target.value, })}/>
                </div>


              </div>
            }

          })()
        }

        <div className="ws-12 pm">
          <button type="button" className="icon-btn close pull-right width110 height35" onClick={() => onCloseDrawer()}> Close <i className="icon-close2"></i></button>
          <button type="button" className="icon-btn delete pull-right width110 height35" onClick={() => resetFilter()}>  Refresh <i className="icon-refresh"></i></button>
          <button type="button" className="icon-btn edit pull-right width110 height35" onClick={() => searchFilter()}>   Search < i className="icon-search"></i></button>
        </div>
      </div>
    </Drawer >
  </>)

}